// Single source of truth for the Button look. `Button` (a <button>) and `ButtonLink` (a navigation action
// rendered as a real link) both build their class string here, so a link-styled action cannot drift from Button.
export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export const buttonBaseClasses =
  'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed';

export const buttonVariantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-brand-600 text-white hover:bg-brand-500 focus:ring-brand-500',
  secondary: 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-700 focus:ring-slate-500',
  outline: 'border border-slate-700 text-white hover:bg-slate-800 focus:ring-slate-500',
  ghost: 'text-white hover:bg-slate-800 focus:ring-slate-500',
  danger: 'bg-red-600 text-white hover:bg-red-500 focus:ring-red-500',
};

export const buttonSizeClasses: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
};

export function buttonClassName({
  variant = 'primary',
  size = 'md',
  className = '',
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
} = {}): string {
  return `${buttonBaseClasses} ${buttonVariantClasses[variant]} ${buttonSizeClasses[size]} ${className}`;
}
